import React from 'react';
import { Switch, Redirect } from 'react-router-dom';

import RouteWithLayout from './components/RouteWithLayout';
import { Main as MainLayout, Minimal as MinimalLayout } from './layouts';
import Login from './views/login/components/Login';
import Admin from './views/admin/components/Admin';
import Projects from './views/Projects/components/Projects';
import CentralView from './views/central/components/CentralView';

import * as routes from './constants/routes';

const Routes = ({ session, refetch }) => {
  return (
    <Switch>
      <Redirect
        exact
        from="/"
        to={routes.LOGIN_ROUTE}
      />
      <RouteWithLayout
        component={Login}
        exact
        layout={MinimalLayout}
        path={routes.LOGIN_ROUTE}
        session={session}
        refetch={refetch}
      />
      <RouteWithLayout
        component={Projects}
        exact
        layout={MainLayout}
        path={routes.PROJECTS_ROUTE}
        session={session}
        refetch={refetch}
      />
      <RouteWithLayout
        component={CentralView}
        exact
        layout={MainLayout}
        path={routes.CENTRAL_ROUTE}
        session={session}
        refetch={refetch}
      />
      <RouteWithLayout
        component={Admin}
        exact
        layout={MainLayout}
        path={routes.ADMIN_ROUTE}
        session={session}
        refetch={refetch}
      />
    </Switch>
  );
};

export default Routes;
